import { type UseQueryResult, useQuery } from 'react-query';
import {
  CustomerUserLogInAndSecurityService,
  // eslint-disable-next-line camelcase
  type Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserSecurityQuestionsAnswersDto,
} from '@wealthlane/api-services/wealthlane-customer-service';

const useGetCustomerSecurityQuestionAnswer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserSecurityQuestionsAnswersDto | undefined,
  unknown
> => {
  const CustomerSecurityQuestionAnswer = useQuery(
    ['getCustomerSecurityQuestionAnswer'],
    async () => {
      return await handleRequest(
        CustomerUserLogInAndSecurityService.getApiCustomerApiAppCustomerUserLogInAndSecurityCustomerUserSecurityQuestionsAnswers()
      );
    }
  );

  return CustomerSecurityQuestionAnswer;
};

export default useGetCustomerSecurityQuestionAnswer;
